export default "__VITE_ASSET__Drpmz2xj__"